import { Notify } from 'quasar'

function calculateTimeout (message) {
  const numberOfCharacters = message.length
  let timeout = (numberOfCharacters * 50) + 300 /* Show Animation Length */ + 1200 /* Hide Animation Length */
  timeout = (timeout < 5000) ? 5000 : timeout
  return timeout
}

Notify.error = function () {
  return Notify.create({
    type: 'negative',
    timeout: 5000,
    message: 'Error has occured',
    position: 'top',
    action: [
      {
        label: 'Dismiss',
        handler: () => {
        }
      }
    ]
  })
}

Notify.respond = function (response) {
  const { success, message } = response
  if (typeof message === 'string') {
    const type = (success) ? 'positive' : 'negative'
    
    // Please do not display system errors to user
    if(message.indexOf('Cannot read') > 0){
      message = 'An error occurred.'
    }

    return Notify.create({
      type: type,
      timeout: calculateTimeout(message),
      message: message,
      position: 'top',
      action: [
        {
          label: 'Dismiss',
          handler: () => {
          }
        }
      ]
    })
  }
}

export default ({ Vue }) => {
  Vue.prototype.$notify = Notify
}

export const notify = Notify
